import moment from 'moment-timezone';

const dayFmt = 'YYYY-MM-DD';

const getDrawSortKey = (match, drawsDict) => {
    const draw = drawsDict?.[match.drawId];
    return draw?.name ?? match.drawId ?? '';
};

const compareMatchesForSchedule = (a, b, drawsDict) => {
    if (moment(a.date).isBefore(b.date)) {
        return -1;
    }
    if (moment(a.date).isAfter(b.date)) {
        return 1;
    }

    const drawKeyA = getDrawSortKey(a, drawsDict);
    const drawKeyB = getDrawSortKey(b, drawsDict);
    if (drawKeyA < drawKeyB) {
        return -1;
    }
    if (drawKeyA > drawKeyB) {
        return 1;
    }

    const roundDiff = (a.roundNumber ?? 0) - (b.roundNumber ?? 0);
    if (roundDiff !== 0) {
        return roundDiff;
    }

    return (a.matchPosition ?? 0) - (b.matchPosition ?? 0);
};

const sortMatchesByMatchTime = (matchesArray, drawsDict) => [...matchesArray].sort(
    (a, b) => compareMatchesForSchedule(a, b, drawsDict),
);

export const sortMatchesWithLocation = (matchesArray, drawsDict) => {
    const { withLocation, withoutLocation } = matchesArray.reduce((acc, match) => {
        if (match.locationId) {
            acc.withLocation.push(match);
        } else {
            acc.withoutLocation.push(match);
        }
        return acc;
    }, { withLocation: [], withoutLocation: [] });

    return [
        ...sortMatchesByMatchTime(withLocation, drawsDict),
        ...sortMatchesByMatchTime(withoutLocation, drawsDict),
    ];
};

const dayInEvent = (isoUtcString, eventTimeZone) => {
    const m = moment.utc(isoUtcString);
    return (eventTimeZone ? m.tz(eventTimeZone) : m).format(dayFmt);
};

export const filterMatchesByDate = (matchesArray, dayStr, eventTimeZone) => {
    return matchesArray.filter(match => dayInEvent(match.date, eventTimeZone) === dayStr);
};

export const filterMatchesByFacility = (matchesArray, facilityName) => {
    return matchesArray.filter(match => match.facilityName === facilityName);
};

export const filterMatchesByDraw = (matchesArray, drawId, drawsDict) => matchesArray.filter(match => {
    const matchDraw = drawsDict[match.drawId];
    return matchDraw.parentDrawId === drawId || matchDraw.id === drawId;
});
